import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
const _excluded = ["address", "propertyAddress"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { CONSTANTS, BackdropLoader, getUtility, Icon, toast } from '@livable/saas-react-components';
import { Typography, Accordion, AccordionSummary, AccordionDetails, Chip } from '@mui/material';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { billStatuses } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import SubmeterAllocationForm from './SubmeterAllocationForm';
import useAllocationUtilityStyles from '../AllocationUtility/styles';
import { generateAddressString } from 'src/utils/address';
const AllocationSubmeteredUtility = observer(props => {
  var _statuses$SubmeterCha, _statuses$SubmeterCha2, _utility$bill;
  const allocationMethod = props.allocationMethod,
    billStatus = props.billStatus,
    cycleId = props.cycleId,
    _props$expanded = props.expanded,
    expanded = _props$expanded === void 0 ? false : _props$expanded,
    fromHistory = props.fromHistory,
    isSkipped = props.isSkipped,
    utilityId = props.utilityId;
  const classes = useAllocationUtilityStyles();
  const history = useLocation();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const queue = store.allocations.queue;
  const selectedBillingCycleId = store.allocations.selectedBillingCycleId;
  const selectedCycle = store.allocations.history.filter(cycle => cycle.id === cycleId)[0];
  const statuses = billStatuses(t);
  const utility = store.allocations.utilityById.get(selectedBillingCycleId + utilityId) || {};
  const utilityUpdateTimestamp = store.allocations.utilityByIdTimestamp.get(selectedBillingCycleId + utilityId);
  const utilityBillStatus = utility.billStatus || billStatus;
  const utilityProviderData = store.utilityProviders.utilities.get(utilityId);
  const utilityData = getUtility(utilityProviderData === null || utilityProviderData === void 0 ? void 0 : utilityProviderData.utilityTypeName);
  const urlParams = new URLSearchParams(history.search);
  const propertyId = urlParams.get('propertyId');
  const id = selectedBillingCycleId + propertyId + utilityId;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(expanded),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    sentStatus = _useState6[0],
    setSentStatus = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    propertyData = _useState8[0],
    setPropertyData = _useState8[1];
  const getAllocationPreview = async data => {
    const resp = await store.allocations.getAllocationPreviewAsync.run(data);
    return resp;
  };
  const getProperty = async data => {
    const resp = await store.properties.getPropertyAsync.run(data);
    return resp;
  };
  const postTableApproval = async data => {
    const resp = await store.allocations.postTableApprovalAsync.run(data);
    return resp;
  };
  useEffect(() => {
    if (isExpanded !== expanded) setIsExpanded(expanded);
    getProperty({
      propertyId
    }).then(async resp => {
      if (!resp) return;
      const _resp$response = resp.response,
        address = _resp$response.address,
        propertyAddress = _resp$response.propertyAddress,
        rest = _objectWithoutProperties(_resp$response, _excluded);
      setPropertyData(_objectSpread({
        propertyAddress: generateAddressString(address)
      }, rest));
    });
  }, [expanded]);
  useEffect(() => {
    if (isExpanded && !store.allocations.utilityById.get(selectedBillingCycleId + utilityId)) {
      setIsLoading(id);
      store.allocations.addToQueue({
        billingCycleId: selectedBillingCycleId,
        id,
        propertyId,
        utilityId
      });
    }
  }, [isExpanded]);
  useEffect(() => {
    if (isLoading === true || isLoading === false || isLoading === 'approve') {
      postTableApproval({
        allocationCycleId: cycleId,
        billingCycleId: selectedBillingCycleId,
        isApproved: isLoading === 'approve',
        isSkipped: isLoading === 'approve' ? false : isSkipped,
        propertyId,
        utilityId: utilityId
      }).then(() => {
        toast('success', {
          body: ["Bill successfully ".concat(isLoading === 'approve' ? 'approved' : 'updated')]
        });
        return getAllocationPreview({
          billingCycleId: selectedBillingCycleId,
          propertyId
        });
      }).finally(() => setIsLoading(null));
    }
  }, [isLoading]);
  useEffect(() => {
    if (!queue.find(item => item.id === id)) setIsLoading('');
  }, [queue]);
  const billStatusClickHandler = e => {
    e.stopPropagation();
    // TO DO
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.allocationUtility
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading === true || isLoading === false
  }), /*#__PURE__*/React.createElement("div", {
    "data-tut": "reactour__allocation-table"
  }, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isExpanded,
    onChange: () => {
      if (store.residencies.getAllResidenciesRelatedToSpecificBuildingAggregateAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress || store.buildings.getBuildingAsync.inProgress || store.allocations.postGetSubMeterFinalStateAsync.inProgress) return;
      setIsExpanded(!isExpanded);
    }
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    className: classes.accordionSummary,
    expandIcon: isSkipped || store.residencies.getAllResidenciesRelatedToSpecificBuildingAggregateAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress || store.buildings.getBuildingAsync.inProgress || store.allocations.postGetSubMeterFinalStateAsync.inProgress ? null : /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.utility,
    "data-tut": "reactour__allocation-utility"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.utilityTitleWrapper
  }, utilityData.icon({
    svgType: 'static',
    pattern: 'gradient-inside-square'
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, utilityData.title), /*#__PURE__*/React.createElement(Typography, {
    className: classes.leftSpace,
    color: "light",
    variant: "body1"
  }, "(", utilityProviderData === null || utilityProviderData === void 0 ? void 0 : utilityProviderData.providerName, ")")), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('allocations.allocated_by'), " ", CONSTANTS.ALLOCATION_METHODS[allocationMethod]))), /*#__PURE__*/React.createElement("div", {
    className: classes.flex,
    onClick: billStatusClickHandler
  }, !isSkipped && utilityBillStatus ? /*#__PURE__*/React.createElement("div", {
    className: classes.utilityBillStatus
  }, (store.residencies.getAllResidenciesRelatedToSpecificBuildingAggregateAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress || store.buildings.getBuildingAsync.inProgress || store.allocations.postGetSubMeterFinalStateAsync.inProgress) && /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    isSpinning: true,
    pattern: "gradient",
    type: "loader"
  }), !(store.residencies.getAllResidenciesRelatedToSpecificBuildingAggregateAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress || store.buildings.getBuildingAsync.inProgress || store.allocations.postGetSubMeterFinalStateAsync.inProgress) && sentStatus && /*#__PURE__*/React.createElement(Chip, {
    label: (_statuses$SubmeterCha = statuses.SubmeterChargesSent) === null || _statuses$SubmeterCha === void 0 ? void 0 : _statuses$SubmeterCha.label,
    size: "large",
    variant: (_statuses$SubmeterCha2 = statuses.SubmeterChargesSent) === null || _statuses$SubmeterCha2 === void 0 ? void 0 : _statuses$SubmeterCha2.variant
  })) : null))), /*#__PURE__*/React.createElement(AccordionDetails, null, isSkipped ? null : /*#__PURE__*/React.createElement(SubmeterAllocationForm, {
    billId: ((_utility$bill = utility.bill) === null || _utility$bill === void 0 ? void 0 : _utility$bill.id) || '',
    fromHistory: fromHistory,
    sentStatus: sentStatus,
    setSentStatus: setSentStatus,
    isUtilityLoading: isLoading,
    propertyId: propertyId,
    selectedCycleStartDate: selectedCycle === null || selectedCycle === void 0 ? void 0 : selectedCycle.startDateOnly,
    utility: toJS(utility),
    utilityName: utilityData.title,
    utilityUpdateTimestamp: utilityUpdateTimestamp,
    propertyAddress: propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyAddress,
    allocationCycleId: cycleId,
    utilityId: utilityId
  })))));
});
export default AllocationSubmeteredUtility;